import { RootState } from 'store/configureStore';
import { TaskStatuses, ITask } from '../../Task';

const todoTasksFunc = (state: RootState): ITask[] => {
  const { tasks } = state.cmTasks;
  return tasks.filter((task) => task.equalsStatus(TaskStatuses.TO_DO));
};

export default todoTasksFunc;
